import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0 w-full',
    wrapper: 'relative overflow-hidden',
    label:
      'text-secondary-hover peer-disabled:text-inactive absolute top-3 left-4 -z-10 origin-[0] -translate-y-3.5 scale-75 transform font-light whitespace-nowrap transition-all duration-200 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-3.5 peer-focus:scale-75',
    input:
      'peer focus:placeholder:text-secondary-hover disabled:placeholder:text-inactive disabled:text-inactive block w-full appearance-none border-0 border-b-1 border-black px-4 pb-1 font-light transition-all duration-200 placeholder:text-transparent placeholder:opacity-0 placeholder:transition-all placeholder:duration-200 focus:outline-none focus:placeholder:opacity-100 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
    helperText: 'text-inactive px-4 pt-1 text-sm font-light',
    iconContainer: 'text-icon-secondary absolute right-4 bottom-3.5 h-6 w-6',
    required: 'ml-0.5'
  },
  variants: {
    error: {
      true: {
        helperText: 'text-error',
        input: 'text-error'
      }
    },
    success: {
      true: {
        helperText: 'text-success'
      }
    },
    icon: {
      true: {
        input: 'pr-12'
      }
    },
    withLabel: {
      true: {
        input: 'mt-5'
      },
      false: {
        input:
          'placeholder:text-secondary-hover pt-4 pb-3 placeholder:opacity-100'
      }
    }
  }
});
